export default "__VITE_ASSET__73GakQIK__"